var exports = {
  "text": "x24da60e8--bd5624--text",
  "primary": "x24da60e8--bd5624--primary",
  "current-color": "x24da60e8--bd5624--current-color",
  "normal": "x24da60e8--bd5624--normal",
  "bold": "x24da60e8--bd5624--bold",
};

module.exports = exports;
